<template>
  <p
    v-if="text || !!$slots.default"
    class="field__notes"
  >
    <span
      v-if="!$slots.default"
      v-html="text"
    />
    <slot />
  </p>
</template>

<script>

export default {
  name: 'InputfieldNotes',
  props: {
    text: {
      type: String,
      required: false,
      default () {
        return ''
      },
    },
  },
}

</script>

<style lang="scss" scoped>

</style>
